const isErrorFunction = (error) => typeof error === "function";
export { isErrorFunction };
